import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {Button, Dropdown, Form, Modal} from "semantic-ui-react";
import {RootState} from "../../app/store";
import {useSelector} from "react-redux";
import {showErrorToast} from "../../utils/showToast";
import {useAppDispatch} from "../../app/hooks";
import {ChangeRole} from "./TablesActions";

interface IChangeRoleModal {
  open: boolean;
  onClose: () => void;
  user?: any;
}
export const ChangeRoleModal = ({open, onClose, user}: IChangeRoleModal) => {
  const {t} = useTranslation();
  const [role, setRole] = useState<string>(user?.roleId || "");
  const employees = useSelector((state: RootState) => state.refData.employees);
  const dispatch = useAppDispatch();
  const companyId = useSelector((state: RootState) => state.auth.companyId);
  const roleOptions = [
    {key: "user", text: t("user"), value: "user"},
    {key: "admin", text: t("admin"), value: "admin"},
  ];

  useEffect(() => {
    if (open) {
      setRole(user?.roleId || "");
    }
  }, [open, user]);

  const handleChange = (e: any, data: any) => {
    setRole(data.value);
  };
  const handleConfirm = () => {
    if (user.roleId !== role) {
      if (role === "user" && employees.filter((emp: any) => emp.roleId === "admin").length === 1) {
        showErrorToast(t("error"), t("last_admin_role_err"));
        return;
      }
      dispatch(ChangeRole(user.email, role, companyId));
    }
    onClose();
  };

  if (!user) {
    return null;
  }

  return (
    <Modal open={open} onClose={onClose} size="small">
      <Modal.Header>{t("change_role_modal")}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field>
            <label>{t("email")}</label>
            <input value={user.email} readOnly />
          </Form.Field>
          <Form.Field>
            <label>{t("role")}</label>
            <Dropdown selection options={roleOptions} value={role} onChange={handleChange} placeholder={t("role")} />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color="black" onClick={onClose}>
          {t("cancel_btn")}
        </Button>
        <Button onClick={handleConfirm} basic positive>
          {t("create_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
